import React, { useEffect, useState, Suspense } from 'react';
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Navigation from "_content/Navigation.js";
import { Link, useLocation } from 'react-router-dom';
import Content from "_content/SeoContent.js";
import ChartContainer from 'components/custom/ChartAndFeatures.js';


import HeaderBase, {
  LogoLink as LogoLinkBase,
} from "components/headers/light.js";


import { Container as ContainerBase, ContentWithVerticalPadding, Content2Xl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import logoImageSrc from "images/logo-light.svg";
import headerImage from "images/gunbot-interface.png";
import translationsHome from 'translations/home/en.js'

const PrimaryBackgroundContainer = styled.div`
${tw`-mx-8 px-8 bg-primary-900 text-gray-100`}
  background-color: #1a1a1a;
  background-image:
    radial-gradient(circle at 60% 70%, rgba(15, 35, 55, 0.95) 0%, rgba(25, 45, 65, 0.90) 50%, rgba(10, 30, 50, 0) 100%, transparent 100%),
    radial-gradient(circle at 50% 50%, rgba(20, 40, 60, 0.95) 0%, transparent 100%);
`;
const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8`;
const LogoLink = tw(LogoLinkBase)`text-gray-100 -mt-4`;

const Container = tw(ContainerBase)`-mt-16 mb-8`;
const Row = tw.div`flex items-center flex-col lg:flex-row`;
const Column = tw.div`lg:w-1/2`;
const TextColumn = tw.div`text-left`;
const IllustrationColumn = tw(Column)`mt-16 lg:mt-0 lg:ml-16 hidden md:block`;
const Heading = tw(SectionHeading)`max-w-3xl lg:max-w-4xl text-left leading-tight text-3xl`;
const Description = tw(SectionDescription)`mt-4 max-w-2xl text-gray-100 text-base mx-auto lg:mx-0`;


const Actions = styled.div`
  ${tw`mb-8 lg:mb-0 mt-6`}
  .action {
    ${tw`text-center inline-block w-full sm:w-48 py-4 font-semibold tracking-wide rounded hocus:outline-none focus:shadow-outline transition duration-300`}
  }
  .primaryAction {
    ${tw`bg-primary-400 text-gray-100 hover:bg-primary-500`}
  }
  .secondaryAction {
    ${tw`mt-4 sm:mt-0 sm:ml-4 bg-gray-300 text-gray-700 hover:bg-gray-400 hover:text-gray-800`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;

export default ({
  primaryActionText = "Learn more",
  primaryActionUrl = "/",
  secondaryActionText = "Check performance",
  secondaryActionUrl = "/performance/",
  imageSrc = headerImage,

}) => {
  const logoLink = (
    <LogoLink to={(window?.location?.href || '').includes('/es') ? "/es/" : "/"}>
      <img src={logoImageSrc} alt="Gunbot logo" width="40px" height="40px" style={{ width: "40px", height: "40px" }} />
      <a href={(window?.location?.href || '').includes('/es') ? "/es/" : "/"} rel="noopener noreferrer">
        Gunbot
      </a>

    </LogoLink>
  );
  const [urlPath, setUrlPath] = useState("");
  let location = useLocation()

  useEffect(() => {
    let addSlash = !location.pathname.endsWith('/')
    const pathRef = addSlash ? location.pathname + '/' : location.pathname
    if (Object.keys(Content.pages).includes(pathRef)) {
      setUrlPath(pathRef)
    }
  }, [location]);

  const heading = Content.pages[urlPath].heading || "";
  const notification = Content.pages[urlPath].notification || "";
  const heroDescription = Content.pages[urlPath].heroDescription || "";

  return (
    <PrimaryBackgroundContainer>
      <Content2Xl>
        <Header logoLink={logoLink} links={<Navigation />} />
        <Container>
          <ContentWithVerticalPadding>
            <Row>
              <TextColumn>
                <Notification>{notification}</Notification>
                <Heading>{heading}</Heading>
                <Description>{heroDescription}</Description>
                <br />
                <Actions>
                  <Link to={primaryActionUrl} title="Learn more about Gunbot" className="action primaryAction">
                    {primaryActionText}
                  </Link>
                </Actions>
              </TextColumn>
              <IllustrationColumn style={{ minWidth: '50%' }}>
                <ChartContainer style={{ width: '752px' }} translations={translationsHome} />              </IllustrationColumn>
            </Row>
          </ContentWithVerticalPadding>
        </Container>
      </Content2Xl>
    </PrimaryBackgroundContainer>
  );
};
